/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './CustomVideo.scss';

import React, { createRef } from 'react';

const MARYLAND_529 = 'maryland529';

const getSurveyId = () => 'troweprice_maryland';
const getAnalyticsToken = () => 'sf-00000258';

function SundaySkyVideo({ analyticsToken, identifier, poster, videoUrl }) {
  const node = React.createElement('sundaysky-video', {
    id: identifier,
    'analytics-token': analyticsToken,
    session: videoUrl,
    poster: poster
  });
  return node;
}

function SundaySkySurvey({ surveyIdentifier, showAt, playerIdentifier }) {
  const node = React.createElement('sundaysky-survey', {
    id: surveyIdentifier,
    player: playerIdentifier,
    'show-at': showAt,
    'survey-id': surveyIdentifier
  });
  return node;
}

export default class CustomVideo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      identifier: 'sskyplayer',
      player: null,
      surveyId: getSurveyId(),
      analyticsToken: getAnalyticsToken()
    };

    this.customVideo = createRef();
  }

  render() {
    const { analyticsToken, identifier, surveyId } = this.state;
    const { videoUrl, poster, productType } = this.props;

    return (
      <div className="custom-video">
        <div className="video-container" ref={this.customVideo} id="sskydiv">
          <SundaySkyVideo
            videoUrl={videoUrl}
            analyticsToken={analyticsToken}
            identifier={identifier}
            poster={poster}
          />
        </div>
        {productType === MARYLAND_529 && (
          <span className="custom-video-survey">
            <SundaySkySurvey
              id="ssk-survey"
              playerIdentifier={identifier}
              surveyIdentifier={surveyId}
              showAt={0.95}
            />
          </span>
        )}
      </div>
    );
  }
}
